import React, { useState } from "react";

import ContentFaleConosco from "components/MI/fale-conosco/Content";
import FAQFaleConosco from "components/MI/fale-conosco/FAQ";
import Navbar from "components/MI/Navbar";
import UserMenu from "components/layout/userMenuNew";

import {
  Body,
  Container,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
} from "./styles";

const titles = {
  inicio: {
    title: "Olá! Como podemos ajudar?",
    subtitle: "Selecione a melhor opção para lhe atendermos",
  },
  "duvidas-frequentes": {
    title: "Dúvidas frequentes",
    subtitle: "Selecione o que faz mais sentido para você!",
  },
};

const FaleConoscoMi = (): JSX.Element => {
  const [page, setPage] = useState("inicio");

  const pages = {
    inicio: <ContentFaleConosco setPage={setPage} />,
    "duvidas-frequentes": <FAQFaleConosco setPage={setPage} />,
  };

  return (
    <Navbar selected="contato">
      <UserMenu />
      <Container>
        <Header>
          <HeaderInfos>
            <HeaderTitle>{titles[page].title}</HeaderTitle>
            <HeaderSubtitle>{titles[page].subtitle}</HeaderSubtitle>
          </HeaderInfos>
        </Header>
        <Body>{pages[page]}</Body>
      </Container>
    </Navbar>
  );
};

export default FaleConoscoMi;
